"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.randomKey = exports.normalizeBlock = exports.htmlToBlocks = exports.getBlockContentFeatures = exports.default = exports.EDITOR_DEFAULT_BLOCK_TYPE = void 0;

var _blockContentTypeFeatures = _interopRequireDefault(require("./util/blockContentTypeFeatures"));

var _HtmlDeserializer = _interopRequireDefault(require("./HtmlDeserializer"));

var _constants = require("./constants");

var _normalizeBlock2 = _interopRequireDefault(require("./util/normalizeBlock"));

var _randomKey2 = _interopRequireDefault(require("./util/randomKey"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * BlockTools - various tools for Sanity block content
 *
 * @param {Object} blockContentType
 *    The compiled schema for the block content type to work with
 *
 */
var blockContentFunctions = {
  /**
   * Convert HTML to blocks respecting the block content type's schema
   *
   * @param {String} html
   *
   * @param {Object} options
   *   @property {Object} blockContentType
   *      A compiled version of the schema type for the block content
   *   @property {Array} rules
   *      Optional rules working on the HTML (will be ruled first)
   *   @property {Function} parseHtml
   *      API compatible model as returned from DOMParser for using server side.
   * @returns {Array} Blocks
   */
  htmlToBlocks(html, blockContentType) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var deserializer = new _HtmlDeserializer.default(blockContentType, options);
    return deserializer.deserialize(html).map(_normalizeBlock2.default);
  },

  /**
   * Returns the feature-set of a compiled block content type.
   *
   * @param {Object} blockContentType
   * @returns {Object} The feature-set
   */
  getBlockContentFeatures(blockContentType) {
    return (0, _blockContentTypeFeatures.default)(blockContentType);
  },

  randomKey(length) {
    return (0, _randomKey2.default)(length);
  }

};
var _default = blockContentFunctions;
exports.default = _default;
var EDITOR_DEFAULT_BLOCK_TYPE = _constants.SLATE_DEFAULT_BLOCK;
exports.EDITOR_DEFAULT_BLOCK_TYPE = EDITOR_DEFAULT_BLOCK_TYPE;
var htmlToBlocks = blockContentFunctions.htmlToBlocks;
exports.htmlToBlocks = htmlToBlocks;
var getBlockContentFeatures = blockContentFunctions.getBlockContentFeatures;
exports.getBlockContentFeatures = getBlockContentFeatures;
var normalizeBlock = _normalizeBlock2.default;
exports.normalizeBlock = normalizeBlock;
var randomKey = _randomKey2.default;
exports.randomKey = randomKey;